import {stateRegistry} from 'microkernel';

stateRegistry.subscribeToStore('dbadPageStore', function (state) {
	window.dbadPageStore = state;
});
